import userAvatar from '../../utils/userAvatar'
import ProfilePopup from '../profile-popup/index'
import Preact, { Component } from 'preact'

class UserAvatar extends Component {
  constructor (props) {
    super(props)

    this.ref = Preact.createRef()

    this.state = {
      ref: false,
      disablePopup: (window.inSidedData ? window.inSidedData.device !== 'desktop' : false) || props.disablePopup
    }
  }

  componentDidMount () {
    this.setState({ ref: true })
  }

  render (props, state) {
    const { user, extraClass, showRank, style, openInNewTab } = props
    const { disablePopup } = state

    if (user.id) {
      return <div class={'avatar ' + (extraClass || '')} style={Object.assign({ float: 'none' }, style)}>
        <div class='profilepicture qa-profile-picture' ref={r => { this.ref = r }} >
          <a class='default-avatar-link qa-topic-meta-last-user-icon' href={user.url ? user.url : `/members/${user.name.toLowerCase()}-${user.id}`} target={openInNewTab ? '_blank' : null}>
            {userAvatar.isDefaultAvatar(user.avatar)
              ? <div class={'default-avatar ' + userAvatar.getAvatarClass(user.id)}>
                {userAvatar.getAvatarInital(user.name)}
              </div>
              : <img src={user.avatar} style={{ width: '100%' }} /> }
            {showRank && user.rank && user.rank.avatarIconUrl
              ? <div class='profilelabel qa-profile-label'><img src={user.rank.avatarIconUrl} title={user.rank.name} /></div>
              : null }
          </a>
          {
            state.ref && !disablePopup && (
              <ProfilePopup
                hoverControl={this.ref}
                memberId={user.id}
                size={{ width: 400, height: 200 }} />
            )
          }
        </div>
      </div>
    }
    return <div class={'avatar ' + (extraClass || '')} style={Object.assign({ float: 'none' }, style)}>
      <div class='profilepicture qa-profile-picture default-avatar-link qa-topic-meta-last-user-icon default-cursor'>
        <div class={'default-avatar ' + userAvatar.getAvatarClass(user.id)}>
          {userAvatar.getAvatarInital(user.name)}
        </div>
      </div>
    </div>
  }
}

export default UserAvatar
